<app-page-wrapper className="level broedels" >

    <section class="HUD">
      <div class="avatar-wrapper">
            <app-avatar2 class="avatar-holder"></app-avatar2>
      </div>

      <!-- Header with active level -->
      <!-- <app-img-badge class="level-icon"  [activeLevelId]="activeLevel?.order"></app-img-badge> -->


      <!-- Bottom notification -->
      <!-- <section class="bottom-notification" *ngIf="showBottomNotification">
              <span class="play-icon" (click)="playText(); audio.playSoundClick();"></span>
              <h3>{{bottomNotification}}</h3>
            </section> -->

      <!-- <section class="bottom-left">
              <div class="button yellow raised" [ngClass]="{'hidden': hideBackButton }" (click)="btnBackClick(); audio.playSoundClick();">
                <span class="button_text">{{audio.text.global.back}}</span>
              </div>
            </section> -->

      <app-button-back *ngIf="!hideBackButton" (click)="btnBackClick(); audio.playSoundClick();">
        {{audio.text.global.back}}
      </app-button-back>

      <router-outlet name="game" (activate)="onActivate($event)"></router-outlet>
      <!-- <app-game [activeLevelId]="activeLevel.order" [activeGame]="activeGame" (onClose)="onCloseGame()" *ngIf="showGame"></app-game> -->

    </section>

    <!-- Roadmap icons and streets -->
    <section class="roadmap" [ngClass]="{disabled: showGame}">
      <div class="map" (onSVGInserted)="roadmapLoaded($event)" [inlineSVG]="svgImage" *ngIf="activeLevel"></div>
    </section>


    <app-textblock (playClicked)="playText(); audio.playSoundClick();" *ngIf="showBottomNotification">
      <div [innerHTML]="bottomNotification"></div>
    </app-textblock>
    <!-- <input type="number" (input)="roadmapLoaded($event)" style="height: 100px;"/>-->
    <app-button-liedje *ngIf="showLiedje"></app-button-liedje>
</app-page-wrapper>
